module.exports = __webpack_public_path__ + "static/007_Gippsland-8b57d7d04098bf247e8d373d0a512e5d.png";